import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions} from "../../../../utils/formatar";
import DatePicker from "react-datepicker";
import moment from "moment";

@inject("store")
@observer
export class DataProrrogacao extends Component {

    static propTypes = {
        momentDataInicio: PropTypes.object,
        momentDataTermino: PropTypes.object,
        quantidadeRecursos: PropTypes.number,
        isSolicitacaoProrrogacao: PropTypes.bool
    };

    constructor(props) {
        super(props);
    }

    render() {
        const dataInicioProrrogacao = this.props.controller.dataInicioProrrogacao;
        const quantidadeDiasProrrogacao = this.props.controller.quantidadeDiasProrrogacao;
        const momentDataFinalProrrogada = this.props.controller.momentDataFinalProrrogada;
        const dataProrrogacaoMin = this.props.controller.dataProrrogacaoMin;
        const dataProrrogacaoMax = this.props.controller.dataProrrogacaoMax;
        const quantidadeDiasProrrogacaoRegulamentada = this.props.controller.quantidadeDiasProrrogacaoRegulamentada;

        let msgPrazoRegulamentado = ''
        if(momentDataFinalProrrogada && quantidadeDiasProrrogacao < quantidadeDiasProrrogacaoRegulamentada && moment(momentDataFinalProrrogada).isAfter(dataProrrogacaoMin)) {
            msgPrazoRegulamentado = <span style={{color: 'darkorange', display: 'block'}}>A quantidade de dias prorrogados é inferior ao regulamentado, seus indicadores serão afetados</span>
        }

        return (
            <div>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Data início da prorrogação</Label>
                            <Input type="text" className="form-control" value={dataInicioProrrogacao ? moment(dataInicioProrrogacao).format("DD/MM/YYYY") : ""} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label for="dataFinal">Data final prorrogada <sup>*</sup></Label>
                            {this.props.editavel ? (
                                <div>
                                    <DatePicker
                                        ref="dataFim"
                                        onClickOutside={()=>{this.refs.dataFim.cancelFocusInput(); this.refs.dataFim.setOpen(false);}}
                                        locale={"pt_BR"}
                                        className="form-control"
                                        dateFormat="DD/MM/YYYY"
                                        selectsStart
                                        selected={momentDataFinalProrrogada}
                                        minDate={moment(dataProrrogacaoMin)}
                                        maxDate={moment(dataProrrogacaoMax)}
                                        onChange={(value) => this.props.controller.setDataProrrogacao(value)}
                                        onChangeRaw={(e) => this.props.controller.setDataProrrogacaoCheck(e.target.value)}
                                    />
                                    {dataProrrogacaoMin && dataProrrogacaoMax ? (
                                        <Validacao id="dataProrrogacao"
                                                   valor={this.props.controller.dataFinalProrrogadaValidacao}
                                                   tipo={["isRequired", "isDate",
                                                       "compararDataAnterior", dataProrrogacaoMin.format("DD/MM/YYYY"),
                                                       "compararDataPosterior",dataProrrogacaoMax.format("DD/MM/YYYY")]}/>
                                    ) : (
                                        <Validacao id="dataProrrogacao"
                                                   valor={this.props.controller.dataFinalProrrogadaValidacao}
                                                   tipo={["isRequired", "isDate"]}/>
                                    )}
                                    {msgPrazoRegulamentado}
                                </div>
                            ) : (
                                <Input type="text" value={moment(this.props.controller.momentDataFinalProrrogada).format("DD/MM/YYYY")} readOnly/>
                            )}
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Quantidade dias prorrogação</Label>
                            <Input type="number" value={quantidadeDiasProrrogacao} readOnly/>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}